import type { HeapUserPropertiesInput } from './useHeapUserProperties.types';

function toSortedCommaSeparatedList(values: readonly string[]): string {
  return values
    .map(value => value.trim())
    .filter(Boolean)
    .sort((a, b) => a.localeCompare(b))
    .join(',');
}

export function buildHeapUserProperties(
  input: Readonly<HeapUserPropertiesInput>
): Record<string, string> {
  const moduleName = input.selectedModule?.name;
  const isInstructModule = moduleName === 'Instruct';

  const properties: Record<string, string> = {
    email: input.authData.email,
    firstName: input.authData.firstName,
    lastName: input.authData.lastName,
  };

  if (moduleName) {
    properties.module_active = moduleName;
  }

  const moduleList = toSortedCommaSeparatedList(
    input.modules.map(module => module.name)
  );
  if (moduleList) {
    properties.module_list = moduleList;
  }

  if (!isInstructModule) {
    properties.b2c_ID = input.authData.id;
  }

  const selectedRole = input.selectedOrganization?.roles?.[0];
  if (selectedRole) {
    properties.userrole = selectedRole;
  }

  if (moduleName === 'Manage') {
    const manageRole = toSortedCommaSeparatedList(
      input.selectedOrganization?.roles ?? []
    );
    if (manageRole) {
      properties.module_manage_role = manageRole;
    }
  }

  if (!isInstructModule && input.selectedOrganization?.customerId) {
    properties.company_active_sf_ID = input.selectedOrganization.customerId;
    properties.company_active_name = input.selectedOrganization.name;
  }

  const sortedOrgs = [...input.organizations].sort((a, b) =>
    a.name.localeCompare(b.name)
  );

  const companyListId = sortedOrgs
    .map(org => org.customerId)
    .filter(Boolean)
    .join(',');
  if (companyListId) {
    properties.company_list_sf_ID = companyListId;
  }

  const companyListName = sortedOrgs
    .map(org => org.name)
    .filter(Boolean)
    .join(',');
  if (companyListName) {
    properties.company_list_name = companyListName;
  }

  return properties;
}
